import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_CREATE_WATCH_PARTY]: 'Watch Party',
}



